import { render, staticRenderFns } from "./CelebrityListing.vue?vue&type=template&id=16f2f7e4&scoped=true&"
import script from "./CelebrityListing.vue?vue&type=script&lang=js&"
export * from "./CelebrityListing.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/video-listings.scss?vue&type=style&index=0&id=16f2f7e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f2f7e4",
  null
  
)

export default component.exports